import type {ActionType} from 'constants/flow/flowTypes';
import {CHECKOUT_STEPS} from 'constants/checkout';
import {DEFAULT_COUNTRY} from 'constants/location';

import {totalsAdapterV2} from 'reducers/checkout/totalsAdapter/totalsAdapter';

import type {CheckoutType} from './checkoutType';

export const initialState = {
    currentStep: CHECKOUT_STEPS.SHIPPING,
    defaultCountry: DEFAULT_COUNTRY,
    totals: {
        appliedCoupons: [],
        count: 0,
        discount: null,
        shippingPrice: '0',
        subtotal: '0',
        total: '0',
        taxTotal: '0',
        items: [],
    },
    counterPayment: 0,
};

/**
 * Checkout reducer
 * @param {CheckoutType} state Current state
 * @param {ActionType<CheckoutType>} action Received action
 * @returns {CheckoutType} state New state
 */
export default function checkout(
    state: CheckoutType = initialState,
    action: ActionType<CheckoutType>,
): CheckoutType {
    switch (action.type) {
        case 'CHECKOUT_GET_TOTALS_FULFILLED':
            return {
                ...state,
                totals: totalsAdapterV2(action.payload.data),
            };
        case 'COUNTER_PAYMENT_ADD':
            return {...state, counterPayment: action.counterPayment + 1};
        case 'SET_CURRENT_STEP':
            return {
                ...state,
                previousStep: state.currentStep,
                currentStep: action.currentStep,
            };
        default:
            return state;
    }
}
